import { connect } from "react-redux";

import {
  changeComposeAdvancedOption,
  changeComposeContentType,
  addPoll,
  removePoll,
  changeComposeScheduledAt,
  changeComposeVisibility,
  saveComposeDraft,
} from "flavours/glitch/actions/compose";
import { openModal } from "flavours/glitch/actions/modal";
import { maxMediaAttachments } from "flavours/glitch/initial_state";

import { defaultScheduledAt } from "flavours/glitch/utils/scheduled_at";

import Options from "../components/options";

function mapStateToProps(state) {
  const poll = state.getIn(["compose", "poll"]);
  const media = state.getIn(["compose", "media_attachments"]);
  const pending_media = state.getIn(["compose", "pending_media_attachments"]);
  return {
    acceptContentTypes: state.getIn(["media_attachments", "accept_content_types"]).toArray().join(","),
    resetFileKey: state.getIn(["compose", "resetFileKey"]),
    hasPoll: !!poll,
    allowMedia: !poll && (media ? media.size + pending_media < maxMediaAttachments && !media.some(item => ["video", "audio"].includes(item.get("type"))) : pending_media < maxMediaAttachments),
    allowPoll: !(media && !!media.size),
    showContentTypeChoice: state.getIn(["local_settings", "show_content_type_choice"]),
    contentType: state.getIn(["compose", "content_type"]),
    scheduled: !!state.getIn(["compose", "scheduled_at"]),
    privacy: state.getIn(["compose", "privacy"]),
    language: state.getIn(["compose", "language"]),
    localOnly: !!state.getIn(["compose", "advanced_options", "do_not_federate"]),
    threaded: !!state.getIn(["compose", "advanced_options", "threaded_mode"]),
    canSaveDraft: state.getIn(["compose", "id"]) === null && (state.getIn(["compose", "text"], "").trim().length > 0 || !!(media && media.size)),
  };
}

const mapDispatchToProps = (dispatch) => ({

  onChangeAdvancedOption(option, value) {
    dispatch(changeComposeAdvancedOption(option, value));
  },

  onChangeVisibility(value) {
    dispatch(changeComposeVisibility(value));
  },

  onChangeContentType(value) {
    dispatch(changeComposeContentType(value));
  },

  onTogglePoll() {
    dispatch((_, getState) => {
      if (getState().getIn(["compose", "poll"])) {
        dispatch(removePoll());
      } else {
        dispatch(addPoll());
      }
    });
  },

  onToggleSchedule() {
    dispatch((_, getState) => {
      dispatch(changeComposeScheduledAt(getState().getIn(["compose", "scheduled_at"]) ? null : defaultScheduledAt()));
    });
  },

  onSaveDraft() {
    dispatch(saveComposeDraft());
  },

  onDoodleOpen() {
    dispatch(openModal({
      modalType: "DOODLE",
      modalProps: { noEsc: true, noClose: true },
    }));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Options);
